// @flow
import * as React from 'react';
import cx from 'classname';
import { withStyles } from '@phg/stilo-toolbox/components/ThemeProvider/index';
import makeStyle from './PartnerizeLogo.style';

type PartnerizeLogoProps = {
    className?: string,
    classes: {
        Logo: string
    }
};

const PartnerizeLogo = ({ classes, className, ...props}: PartnerizeLogoProps) =>
    <div {...props} className={cx(classes.Logo, className)} />;

export default withStyles(makeStyle)(PartnerizeLogo);
